export const SS_OUTPATIENT = 1
export const SS_APPOINTMENTS = 2
export const SS_PROGRAMS = 3
export const SS_PROGRAMS_AND_APPOINTMENTS = 4
export const SS_APPOINTMENT_OPTIONS = [2, 4]
export const SS_PROGRAM_OPTIONS = [3, 4]
